import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/index.vue";
import Login from "@/views/login.vue";
import HomePage from "@/views/HomePage.vue";
import OrderPage from "@/views/OrderPage.vue";
import MyPage from "@/views/MyPage.vue";
import hotGoods from "@/views/hotGoods.vue";
import hotGoodsDetails from "@/views/hotGoodsDetails.vue";
import submitOrder from "@/views/submitOrder.vue";
import Address from "@/views/Address.vue";
import orderDetails from "@/views/orderDetails.vue";
import instructions from "@/views/instructions.vue";
import questions from "@/views/questions.vue";
import AboutUs from "@/views/AboutUs.vue";
import ServiceAgreement from "@/views/ServiceAgreement.vue";
import PrivacyAgreement from "@/views/PrivacyAgreement.vue";
import Search from '@/views/Search.vue'
import Success from '@/views/Success.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: Home,
    redirect: "/HomePage",
    children: [
      {
        path: "/HomePage",
        name: "HomePage",
        component: HomePage,
      },
      {
        path: "/OrderPage",
        name: "OrderPage",
        component: OrderPage,
      },
      {
        path: "/MyPage",
        name: "MyPage",
        component: MyPage,
      },
    ],
  },
  {
    path: "/hotGoods",
    name: "hotGoods",
    component: hotGoods,
  },
  {
    path: "/hotGoodsDetails/:id",
    name: "hotGoodsDetails",
    component: hotGoodsDetails,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/submitOrder",
    name: "submitOrder",
    component: submitOrder,
  },
  {
    path: "/Address",
    name: "Address",
    component: Address,
  },
  {
    path: "/orderDetails/:id",
    name: "orderDetails",
    component: orderDetails,
  },
  {
    path: "/instructions",
    name: "instructions",
    component: instructions,
  },
  {
    path: "/questions",
    name: "questions",
    component: questions,
  },
  {
    path: "/AboutUs",
    name: "AboutUs",
    component: AboutUs,
  },
  {
    path: "/ServiceAgreement",
    name: "ServiceAgreement",
    component: ServiceAgreement,
  },
  {
    path: "/PrivacyAgreement",
    name: "PrivacyAgreement",
    component: PrivacyAgreement,
  },
  {
    path: "/Search",
    name: "Search",
    component: Search,
  },
  {
    path: "/SuccessPay",
    name: "Success",
    component: Success,
  }
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export default router;
